import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBluetoothComponent } from "./med-icon-bluetooth.component";

@NgModule({
  declarations: [
    MedIconBluetoothComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBluetoothComponent,
  ],
})
export class MedIconBluetoothModule { }
